export default "__VITE_ASSET__C01BtUXn__"